import {ConfirmationDialogInstance} from "./ConfirmationDialogInstance";
import {Dialog} from "../../core/Dialog";
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestion, faTrash} from "@fortawesome/free-solid-svg-icons";
import {library} from "@fortawesome/fontawesome-svg-core";

library.add(faQuestion);
library.add(faTrash);
export class ConfirmationDialog {
    public ConfirmationDialogOptions:ConfirmationDialogOptions;
    private _enableCancelButton:boolean=true;
    private _applyText:string='Close';
    private constructor(title:string,content:string){
        this.ConfirmationDialogOptions={
            Title:title,
            Content:content,
            Icon:<FontAwesomeIcon icon={'question'}/>,
            OnApply:null
        }

    }

    public static Create(title:string='',content:any){
        if(title=='')
            title='Please confirm';
        return new ConfirmationDialog(title,content);
    }

    public SetApplyText(text:string){
        this._applyText=text;
        return this;
    }

    public SetIcon(icon:JSX.Element)
    {
        this.ConfirmationDialogOptions.Icon=icon;
        return this;
    }

    public Show():Promise<any>{
        return Dialog.Show(<ConfirmationDialogInstance ApplyText={this._applyText}   EnableCancelButton={this._enableCancelButton}  Options={this.ConfirmationDialogOptions}/>);
    }

    public EnableCancelButton(showCancelButton:boolean){
        this._enableCancelButton=showCancelButton;
        return this;
    }

    public OnApply(callBack:()=>Promise<boolean>){
        this.ConfirmationDialogOptions.OnApply=callBack;
        return this;
    }

    UseDeleteIcon() {
        this.ConfirmationDialogOptions.Icon=<FontAwesomeIcon icon={'trash'}/>;
        return this;
    }
}


export interface ConfirmationDialogOptions{
    Title:string;
    Content:any;
    Icon:JSX.Element
    OnApply:()=>Promise<boolean>;
}